{
	"accounts": "Konten",
	"invitations": "Einladungen",
	"subscribeToFeedback": "Für das Feedback-Programm anmelden",
	"notificationSettings": {
		"title": "E-Mail-Benachrichtigungseinstellungen",
		"invoicingInformation": "Rechnungsinformationen",
		"declarationProcessingStatus": "Deklarationsverarbeitungsstatus",
		"enabled": "Ein",
		"disabled": "Aus",
		"toast": {
			"success": "Benachrichtigungseinstellung aktualisiert",
			"error": "Benachrichtigungseinstellung konnte nicht aktualisiert werden"
		}
	},
	"about": {
		"title": "Über",
		"termsAndConditions": "Allgemeine Geschäftsbedingungen",
		"privacyPolicy": "Datenschutzerklärung",
		"imprint": "Impressum",
		"openSourceAttribution": "Open-Source-Hinweise"
	},
	"language": {
		"title": "Sprache",
		"footer": "Sprachänderungen werden auf alle Heidelberg Materials Anwendungen übertragen"
	},
	"impressum": "Impressum",
	"copyright": "© 2024 Heidelberg Materials. Alle Rechte vorbehalten.",
	"login": "Anmelden",
	"logout": "Abmelden"
}
